import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}products/skistar/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getResorts() {
    return conduit.get('resorts');
  },

  /**
   * @returns {AxiosPromise}
   */
  async getAccommodationsByResortId(resortId, webservice, offset, limit) {
    return conduit.get(`resorts/${resortId}/${webservice}/accommodations-with-subarea-and-area/offset/${offset}/limit/${limit}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getResortSubareas(resortId) {
    return conduit.get(`resorts/${resortId}/subareas`);
  },

  getUnhandledImagesByWebservice(webservice, limit, payload) {
    return conduit.post(`/resorts/unhandled-images/webservice/${webservice}/get-images/limit/${limit}`, payload);
  },

  getTotalUnhandledImagesByWebservice(webservice, payload) {
    return conduit.post(`/resorts/unhandled-images/webservice/${webservice}/get-total-images`, payload);
  },

  updateUnhandledImages(payload) {
    return conduit.post('resorts/unhandled-images/update-images', payload);
  },

  /**
   * @returns {AxiosPromise}
   */
  importAccommodations(requestBody) {
    return conduit.post('accommodations/import', requestBody);
  },

  /**
   * @returns {AxiosPromise}
   */
  getAccommodationTexts(accommodationId) {
    return conduit.get(`accommodations/${accommodationId}/texts`);
  },

  /**
   * @returns {AxiosPromise}
   */
  activateAccommodationImage(accommodationId, identifier) {
    return conduit.put(
      `accommodations/${accommodationId}/images/${identifier}/update-active-status`,
      { active: true },
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  deactivateAccommodationImage(accommodationId, identifier) {
    return conduit.put(
      `accommodations/${accommodationId}/images/${identifier}/update-active-status`,
      { active: false },
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  deleteAccommodationImage(accommodationId, identifier) {
    return conduit.delete(
      `accommodations/${accommodationId}/images/${identifier}`,
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  unmapAccommodation(xmlChannelProductId) {
    return conduit.delete(`accommodations/xmlChannelProductId/${xmlChannelProductId}/unmap`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getResortAddons(webservice) {
    return conduit.get(`addons/${webservice}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  updateAddonTwentyExtraId(addon) {
    return conduit.put(
      'addons/update',
      addon,
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  changeSiteOnAccommodation(accommodationSiteId, siteId) {
    return conduit.put(
      `accommodations/imported/by-accommodation-site/${accommodationSiteId}/change-site`,
      {
        siteId,
      },
    );
  },

  /**
   * @param accommodationSiteId
   * @returns {AxiosPromise}
   */
  getAccommodationSiteWithAccommodation(accommodationSiteId) {
    return conduit.get(`accommodations/imported/by-accommodation-site/${accommodationSiteId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/skistar-service.js